import { signOutRequest } from "@/store/auth/authSlice";
import { imageUrl } from "config/apiUrl";
import { FaUser } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PopperComponent from "../Core/PopperComponent";
import classes from "./ProfileComponent.module.css";

const ProfileDetailsComponent = ({
  variant = "circular",
  collapsed,
  isSelected,
  isMobile,
}) => {
  const { user } = useSelector((state) => state.authReducer);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleLogout = () => {
    navigate("/login");
    dispatch(signOutRequest());
  };

  const handleRedirect = (e) => {
    switch (e?.value) {
      case "Logout":
        handleLogout();
        break;
      case "Profile":
        navigate("/profile-settings");
        break;
      case "Change Password":
        navigate("/profile-settings?tab=password");
        break;
      default:
        navigate(e);
        break;
    }
  };
  return (
    <div
      className={[classes.profileMain, collapsed && classes.collapsed]?.join(
        " "
      )}
    >
      <PopperComponent
        sideOffset={10}
        data={[
          { value: "Profile" },
          { value: "Change Password" },
          { value: "Logout" },
        ]}
        asChild
        side={collapsed ? "right" : "top"}
        align={collapsed ? "end" : "end"}
        handleClick={handleRedirect}
      >
        <div className={classes.profileContainer}>
          <div
            className={[
              classes.imageWrapper,
              variant === "circular" && classes.circular,
              !user?.photo && classes.iconBg,
              isSelected && classes.selected,
            ].join(" ")}
          >
            {user?.photo ? (
              <img
                src={imageUrl(user?.photo)}
                alt={user?.name}
                width={50}
                height={50}
                className={classes.profileImage}
              />
            ) : (
              <FaUser className={classes.userIcon} />
            )}
          </div>
          {!isMobile && (
            <div className={classes.nameRoleDiv}>
              <p>{user?.firstName + " " + user?.lastName || "Gavin Mayers"}</p>
              <p>{user?.role?.replaceAll("-", " ") || "Admin"}</p>
            </div>
          )}
          <span>
            <IoIosArrowDown />
          </span>
        </div>
      </PopperComponent>
    </div>
  );
};

export default ProfileDetailsComponent;
